import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Formule } from 'src/app/models/formule';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { UserService } from 'src/app/services/user.service';
import { ModalController } from '@ionic/angular';


@Component({
  selector: 'app-formuleform',
  templateUrl: './formule-form.component.html',
  styleUrls: ['./formule-form.component.scss'],
})
export class FormuleFormComponent implements OnInit {
  formuleForm: FormGroup;
  @Output() editFormuleEvent = new EventEmitter<string>();
  @Output() creationFormuleEvent = new EventEmitter<string>();
  @Input() title: string = "Ajouter une formule";
  @Input() formuleString: string;
  formule: Formule;
  @Input() foo: Formule;


  constructor(
    private userService: UserService,
    private apiProvider: ApiProviderService,
    private modalCtrl: ModalController,

  ) { }

  ngOnInit() {
    if (!this.foo) {
      this.formuleForm = new FormGroup({
        name: new FormControl('', [Validators.required]),
        price: new FormControl('', [Validators.required]),
        recurrence: new FormControl('', [Validators.required]),
        nbSeances: new FormControl(1),
      })
    } else {
      this.formuleForm = new FormGroup({
        name: new FormControl(this.foo.name, [Validators.required]),
        price: new FormControl(this.foo.price, [Validators.required]),
        recurrence: new FormControl(this.foo.recurrence, [Validators.required]),
        nbSeances: new FormControl(this.foo.nbSeances || 1),
      })
    }

    this.formuleForm.get('recurrence').valueChanges.subscribe(value => {
      if (value === 'Séance') {
        this.formuleForm.get('nbSeances').setValue(1);
      } else {
        this.formuleForm.get('nbSeances').setValue(null);
      }
    });
  }



  testType() {
    if (!this.foo) {
      this.validate();
    }
    else {
      this.apiProvider.editFormule({ ...this.formuleForm.value, id: this.foo.id, coachId: this.userService.getUser().id }).subscribe(
        (res) => {
          this.foo.name = this.formuleForm.controls.name.value;
          this.foo.price = this.formuleForm.controls.price.value;
          this.foo.recurrence = this.formuleForm.controls.recurrence.value;
          this.foo.nbSeances = this.formuleForm.controls.nbSeances.value;
          this.formule = res;
          return this.modalCtrl.dismiss(this.formule, 'edit');
        }
      )
    }
  }



  validate() {
    if (this.formuleForm.invalid) {
      this.formuleForm.markAllAsTouched();
      return
    }
    let formule = new Formule();
    formule.name = this.formuleForm.controls.name.value;
    formule.price = this.formuleForm.controls.price.value;
    formule.recurrence = this.formuleForm.controls.recurrence.value;
    formule.nbSeances = this.formuleForm.controls.nbSeances.value;

    let register = { ...formule, IdCoach: this.userService.getUser().id }

    this.apiProvider.createFormule(register).subscribe(
      (res) => {
        return this.modalCtrl.dismiss({ ...this.formuleForm.value, id: res.id }, 'confirm');
      }
    )


  }
  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }
}